import { useMutation } from '@tanstack/react-query';
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const updateFeedbackStatus = async (
  feedbackId: string,
  newStatus: string
) => {
  const res = await apiManager.patch(`/admin/feedback/${feedbackId}/modify`, {
    status: newStatus,
  });

  return res;
};


export const useUpdateFeedbackStatus = () =>
  useMutation({
    mutationFn: async ({ feedbackId, status }: { feedbackId: string; status: string }) => {
      const res = await apiClient.patch(ENDPOINTS.FEEDBACK.UPDATE_FEEDBACK(feedbackId), { status });
      return res.data;
    },
  });